/**
 * The single registry of per-flow persistence slugs.
 *
 * Every generation flow that wants its in-progress draft to survive the
 * auth / credit wall (Google OAuth, email-confirm new tab, pricing redirect,
 * browser restart) uses one of these keys with `useFlowPersistence`.
 *
 * Adding a new flow: add ONE line here, then call `useFlowPersistence` in the
 * flow's hook (see the recipe atop `src/hooks/useFlowPersistence.ts`). Nothing
 * else — clearing, TTL, sign-out wipe and multi-tab restore are all automatic.
 *
 * The string values are also the localStorage suffix (`flow-state:<slug>`) and
 * the IndexedDB `flowKey`, so they must stay stable once shipped.
 */

export const FLOW_KEYS = {
  PRODUCT_CREATIVE: "product-creative",
  PROFILE_PHOTO: "profile-photo",
  BASEBALL_TREND: "baseball-trend",
  TALKING_AVATAR: "talking-avatar",
  IMAGE_GENERATOR: "generate-image",
  TEXT_TO_VIDEO: "text-to-video",
  FRAMES_TO_VIDEO: "frames-to-video",
  PRODUCT_CATALOG: "generate-product-catalog",
  IMAGE_DIRECTOR_CHAT: "image-director-chat",
} as const;

export type FlowKey = (typeof FLOW_KEYS)[keyof typeof FLOW_KEYS];

/** Every registered flow key — used by the sign-out / cleanup sweep. */
export const ALL_FLOW_KEYS: readonly FlowKey[] = Object.values(FLOW_KEYS);
